import {
  CommentAdapter,
  Resources,
  type CommentSchemaType,
} from "@validereinc/domain";
import { useCreateOne, useDeleteOne, useGetOne } from "./adapterUtils";

export const useGetOneCommentFeed = useGetOne<CommentSchemaType[]>(
  CommentAdapter.feed.getOne,
  Resources.COMMENT
);

export const useCreateOneComment = useCreateOne<CommentSchemaType>(
  CommentAdapter.createOne,
  Resources.COMMENT
);

export const useDeleteOneComment = useDeleteOne<CommentSchemaType>(
  CommentAdapter.deleteOne,
  Resources.COMMENT
);
